import React, { FC } from "react";
import { Field } from "react-final-form";
import { Theme } from "@material-ui/core/styles";
import { makeStyles, Typography } from "@material-ui/core";
import BootstrapInput from "../../../../components/BootstrapInput";
import { ApplicationStatus, ApplicationStatusText } from "../../types";

const useStyles = makeStyles((theme: Theme) => ({
  mainText: {
    fontWeight: "bold",
    marginBottom: 16,
  },
  reasonCnt: {
    height: 150,
  },
}));

interface UpdateStatusContentProps {
  status: ApplicationStatus;
}

export const Content: FC<UpdateStatusContentProps> = ({ status }) => {
  const classes = useStyles();
  const isReasonRequired = status === ApplicationStatus.REJECTED;

  return (
    <form>
      <div>
        <Typography className={classes.mainText}>
          Are you sure you want to change the application status to{" "}
          {ApplicationStatusText[status].toLowerCase()}?
        </Typography>
        {isReasonRequired && (
          <div className={classes.reasonCnt}>
            <Field
              required={true}
              fullWidth
              type="text"
              label={`Comment`}
              placeholder="Please enter comment for the student"
              multiline={true}
              rows={5}
              component={BootstrapInput}
              name={"comment"}
            />
          </div>
        )}
      </div>
    </form>
  );
};
